import { useState } from 'react';
import PropTypes from 'prop-types';

import InputTextLine from '../../../juristec-ui/core/InputTextLine';
import IconButton from '../../../juristec-ui/core/IconButton';
import ActionsGroup from '../../../juristec-ui/core/ActionsGroup';
import Button from '../../../juristec-ui/core/Button';
import { compactString } from '../../../juristec-ui/utils/functions/formatString';
import { verifyCurrentPassword, verifyRepeatNewPassword } from '../../../juristec-ui/utils/validators/inputTextValidators';

import { Visibility, VisibilityOff } from '../../../juristec-ui/icons';

import { MainContainer, InfoText, FormColumn, FormRow } from './styled/ChangeDatabasePassword.styled';

const changeDatabasePasswordDefaultPropSubmit = () => {};

/** Transfers all allowed data from one user to another */
const ChangeDatabasePassword = ({
  close,
  credentialUsername = null,
  credentialPassword = '',
  credentialUrl = null,
  submit = changeDatabasePasswordDefaultPropSubmit,
}) => {
  const [url, setUrl] = useState(credentialUrl);
  const [username, setUsername] = useState(credentialUsername);
  const [showPass, setShowPass] = useState(false);
  const [password, setPassword] = useState({ value: credentialPassword, error: true, errorMsg: '' });
  const [confirmPassword, setConfirmPassword] = useState({ value: credentialPassword, error: true, errorMsg: '' });

  const passwordHandle = (val) => {
    const msg = verifyCurrentPassword(val, '', false);
    setPassword({
      value: val,
      error: msg.length !== 0,
      errorMsg: msg,
    });
  };

  const repeatPasswordHandle = (val) => {
    const msg = verifyRepeatNewPassword(val, password.value);
    setConfirmPassword({
      value: val,
      error: msg.length !== 0,
      errorMsg: msg,
    });
  };

  const urlHandle = (val) => setUrl(val);

  const usernameHandle = (val) => setUsername(val);

  const handleSubmit = () => {
    submit(password.value, url, username);
  };

  return (
    <MainContainer>
      <InfoText>
        Se necessário, altere a URL de acesso da consulta e a senha de acesso.
      </InfoText>
      <FormColumn>
        <FormRow>
          <div style={{ position: 'relative', width: '100%' }}>
            <InputTextLine
              label="URL da Consulta*"
              type="text"
              value={url}
              notTransparent={false}
              onChange={(e) => urlHandle(compactString(e.target.value))}
              style={{ paddingRight: '35px' }}
              autocomplete="new-password"
            />
          </div>
        </FormRow>
        <FormRow>
          <div style={{ position: 'relative', width: '100%' }}>
            <InputTextLine
              label="Username*"
              type="text"
              value={username}
              notTransparent={false}
              onChange={(e) => usernameHandle(compactString(e.target.value))}
              style={{ paddingRight: '35px' }}
              autocomplete="new-password"
            />
          </div>
        </FormRow>
        <FormRow>
          <div style={{ position: 'relative', width: '100%' }}>
            <InputTextLine
              label="Nova Senha*"
              type={!showPass ? 'password' : 'text'}
              value={password.value}
              errorMessage={password.errorMsg}
              error={password.errorMsg.length > 0}
              notTransparent={false}
              onChange={(e) => passwordHandle(compactString(e.target.value))}
              style={{ paddingRight: '35px' }}
              autocomplete="new-password"
            />
            <IconButton
              style={{
                position: 'absolute', bottom: 4, right: 2, boxShadow: 'none', padding: 2,
              }}
              type="button"
              variant="pattern"
              iconColor="black"
              onMouseDown={() => setShowPass(!showPass)}
            >
              {showPass ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </div>
        </FormRow>
        <FormRow>
          <div style={{ position: 'relative', width: '100%' }}>
            <InputTextLine
              label="Confirmar a Senha*"
              type={!showPass ? 'password' : 'text'}
              value={confirmPassword.value}
              errorMessage={confirmPassword.errorMsg}
              error={confirmPassword.errorMsg.length > 0}
              notTransparent={false}
              onChange={(e) => repeatPasswordHandle(compactString(e.target.value))}
              style={{ paddingRight: '35px' }}
            />
            <IconButton
              style={{
                position: 'absolute', bottom: 4, right: 2, boxShadow: 'none', padding: 2,
              }}
              type="button"
              variant="pattern"
              iconColor="black"
              onMouseDown={() => setShowPass(!showPass)}
            >
              {showPass ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </div>
        </FormRow>
      </FormColumn>
      <ActionsGroup>
        <Button
          style={{ margin: '5px' }}
          onClick={close}
          variant="outlined"
          size="large"
        >
          Cancelar
        </Button>
        <Button
          style={{ margin: '5px' }}
          onClick={handleSubmit}
          size="large"
          disabled={password.error || confirmPassword.error}
        >
          Alterar
        </Button>
      </ActionsGroup>
    </MainContainer>
  );
};

ChangeDatabasePassword.propTypes = {
  close: PropTypes.func.isRequired,
  credentialUsername: PropTypes.string || null,
  credentialPassword: PropTypes.string,
  credentialUrl: PropTypes.string || null,
  submit: PropTypes.func,
};

export default ChangeDatabasePassword;
